import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);

// Sensible fallback so the UI renders even before /api/config resolves.
const FALLBACK = {
  brand_name: "VisaFlight",
  whatsapp_number: "2348110949524",
  whatsapp_prefill: "Hello VisaFlight, I have a question about your airline reservation service.",
  currency_symbol: "₦",
  additional_change_fee: 10000,
  paystack_public_key: "",
  services: [
    { id: "standard", name: "Standard", amount: 40000, processing_time: "Within 24 hours", order: 1 },
    { id: "express", name: "Express", amount: 60000, processing_time: "Within 4 hours", order: 2 },
    { id: "priority", name: "Priority", amount: 70000, processing_time: "Within 1 hour", order: 3 },
  ],
};

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/config")
      .then((res) => setConfig(res.data))
      .catch(() => setConfig(FALLBACK));
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return useContext(ConfigContext) || FALLBACK;
}

export function whatsappLink(config, message) {
  const text = encodeURIComponent(message || config.whatsapp_prefill);
  return `https://wa.me/${config.whatsapp_number}?text=${text}`;
}
